// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"styles_sliderWrapper__KZX+G","propertyImage":"styles_propertyImage__R9WS6"};